import { useMemo } from 'react';
import sortBy from 'lodash/sortBy';

import { StudentSectionOverview } from '../student.constants';
import { getStudentSectionsAndSubSectionsOverview } from '../student.utils';
import { INTRODUCTION_SECTION_ID } from 'global/constants';

export const useStudentPresentOverviewData = (
  sectionsOverview: StudentSectionOverview[] | undefined,
  activeSectionId: string
) => {
  const sortedSectionsOverview = useMemo(
    () =>
      sortBy(
        sectionsOverview?.filter(s => s.id !== INTRODUCTION_SECTION_ID),
        'sort'
      ),
    [sectionsOverview]
  );
  const sortedSectionsAndSubSectionsOverview = useMemo(
    () =>
      getStudentSectionsAndSubSectionsOverview(sortedSectionsOverview).filter(
        s => s.isAssigned
      ),
    [sortedSectionsOverview]
  );
  const currentSectionOverviewIndex = useMemo(() => {
    return sortedSectionsAndSubSectionsOverview.findIndex(
      s => s.id === activeSectionId
    );
  }, [activeSectionId, sortedSectionsAndSubSectionsOverview]);

  const hasIntroduction = useMemo(() => {
    return (
      sectionsOverview?.find(s => s.id === INTRODUCTION_SECTION_ID) !==
      undefined
    );
  }, [sectionsOverview]);

  const currentSectionOverview =
    sortedSectionsAndSubSectionsOverview[currentSectionOverviewIndex];

  return {
    sortedSectionsOverview,
    sortedSectionsAndSubSectionsOverview,
    currentSectionOverviewIndex,
    currentSectionOverview,
    hasIntroduction,
  };
};
